import {GlobalLibs, NetworkLibs} from 'bc-react-package'

const COMP_NAME = "WebDataAccess"

// member
// let mobjCallbackFuncTemp = null
// let mobjCallbackOjbectTemp = null
let menumGetJSONTypeTemp = -1


/*===========================================
summary: 取得 必要 書本相關資訊 流程 開始
  param: 

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetPrerequisiteDataFromWebProcessBegin (BookCategoryID)
{
    console.log(COMP_NAME + ".GetPrerequisiteDataFromWebProcessBegin: ", BookCategoryID)

    GetBookCategoryDefFromWeb(BookCategoryID)
    // -> BackFromAppCallbackGetBookCategoryDefFromWeb
    // -> GetAllBookDefFromWeb
    // ->  Loop for: GetBookDefFromWeb
    // ->  GetBookDefFromWebCallback
    // -> GetHomeworkDefinitionFromWeb
    // -> BackFromWebCallbackGetHomeworkDefinitionFromWeb
    // -> GetPrerequisiteDataFromWebProcessEnd
} // end of GetPrerequisiteDataFromWebProcessBegin

/*===========================================
summary: 取得 必要 書本相關資訊 流程 結束
  param: 

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetPrerequisiteDataFromWebProcessEnd ()
{
	console.log(COMP_NAME + ".GetPrerequisiteDataFromWebProcessEnd")

    let objCallObject = {
        Func: "GetPrerequisiteDataEnd"
    }
    window.ComponentFuncEntry.MainRef(objCallObject)
} // end of GetPrerequisiteDataFromWebProcessEnd

/*===========================================
summary: 取得 Lesson資料 流程 開始
  param: 

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetLessonDataFromWebProcessBegin (BookCategoryID, LessonID)
{
    console.log(COMP_NAME + ".GetLessonDataFromWebProcessBegin: ", BookCategoryID, LessonID)

    // remember CallbackFunc and CallbackObject
    // mobjCallbackFuncTemp = CallbackFunc
    // mobjCallbackOjbectTemp = CallbackObject

    GetLessonDefFromWeb(BookCategoryID, LessonID)
    // -> BackFromWebCallbackGetLessonDefFromWeb
    // -> GetLessonDataFromWebProcessEnd
} // end of GetLessonDataFromWebProcessBegin

/*===========================================
summary: 取得 Lesson資料 流程 結束
  param: 

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetLessonDataFromWebProcessEnd (LessonID)
{
    console.log(COMP_NAME + ".GetLessonDataFromWebProcessEnd")

    let objCallObject = {
        Func: "GetLessonDataFromWebProcessEnd",
        LessonID: LessonID

    }
    window.ComponentFuncEntry.LessonsRef(objCallObject)

    // mobjCallbackFuncTemp(mobjCallbackOjbectTemp)

    // mobjCallbackFuncTemp = null
    // mobjCallbackOjbectTemp = null
} // end of GetLessonDataFromWebProcessEnd

// ================== Web GetJSON BEGIN ==================
/*===========================================
summary: Web 取得 系列書 資料 
  param: BookCategoryID: 03

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetBookCategoryDefFromWeb(BookCategoryID)
{
    console.log(COMP_NAME + ".GetBookCategoryDefFromWeb: ", BookCategoryID)

    // BookCategoryID=03

    if (window.gSession.App.BookCategoryDef !== null)
    {
        console.log("BookCategory object not null")
        GetAllBookDefFromWeb(window.gSession.App.BookCatID)
        return
    }

    // 左邊補零 Format "03"
    let strBookCategoryID = BookCategoryID.toString().PadLeft(2)

    menumGetJSONTypeTemp = window.gDCPJsonEnum.BookCategory
    GetDCPContentJson(menumGetJSONTypeTemp, strBookCategoryID)  
} // end of GetBookCategoryDefFromWeb

/*===========================================
summary: Web 取得 系列書 資料 Callback
  param: ReturnData: {"BookCat":{"ID":"03","Name":"Discovering Chinese_new ...

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function BackFromAppCallbackGetBookCategoryDefFromWeb (ReturnData) 
{
    console.log(COMP_NAME + ".BackFromAppCallbackGetBookCategoryDefFromWeb: ", ReturnData)

    // {"BookCat":{"ID":"01","Name":"Discovering Chin

    let objBookCategoryDef = ReturnData.BookCat

    window.gSession.App.BookCategoryDef = objBookCategoryDef

    GetAllBookDefFromWeb(window.gSession.App.BookCatID)
} // end of BackFromAppCallbackGetBookCategoryDefFromWeb

/*===========================================
summary: Web 取得 所有Book 資料
  param: BookCategoryID: 03

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetAllBookDefFromWeb (BookCategoryID)
{
    console.log(COMP_NAME + ".GetAllBookDefFromWeb: ", BookCategoryID)

    // 先假設 BookCategoryID 一定一樣
    let blnEmptyBookObjectFound = false
    let strBookSeqNo = ""
    for (strBookSeqNo in window.gSession.App.BookDef) 
    {
        if (window.gSession.App.BookDef[strBookSeqNo] === null)
        {
            blnEmptyBookObjectFound = true
        }
    }

    console.log("GetAllBookDefFromWeb: blnEmptyBookObjectFound:", blnEmptyBookObjectFound)
    console.log("GetAllBookDefFromWeb: window.gSession.App.BookDef:", window.gSession.App.BookDef)
    // console.log("GetAllBookDefFromWeb: JSON.stringify(window.gSession.App.BookDef):", JSON.stringify(window.gSession.App.BookDef))

    if (!blnEmptyBookObjectFound)
    {
        // should return since every book def is not null
        console.log("Book object not null")
        GetHomeworkDefinitionFromWeb(window.gSession.App.BookCatID)
        return
    }

    // this.GetBookDefFromWeb(BookCategoryID, "03")
    for (strBookSeqNo in window.gSession.App.BookDef) 
    {
        GetBookDefFromWeb(BookCategoryID, strBookSeqNo)
    }

   
} // end of GetAllBookDefFromWeb

/*===========================================
summary: Web 取得 Book 資料
  param: BookCategoryID: 03
         BookSeqNo: 01

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetBookDefFromWeb (BookCategoryID, BookSeqNo)
{
    console.log(COMP_NAME + ".GetBookDefFromWeb: ", BookCategoryID, BookSeqNo)

    // BookCategoryID=03&BookSeqNo=01

    // 左邊補零 Format "03"
    let strBookCategoryID = BookCategoryID.toString().PadLeft(2)

    // 左邊補零 Format "01"
    let strBookSeqNo = BookSeqNo.toString().PadLeft(2)

    menumGetJSONTypeTemp = window.gDCPJsonEnum.Book
    console.log("GetBookDefFromWeb: GetDCPContentJson:", BookCategoryID, BookSeqNo )
    GetDCPContentJson(menumGetJSONTypeTemp, strBookCategoryID, strBookSeqNo)  
} // end of GetBookDefFromWeb

/*===========================================
summary: Web 取得 Book 資料 Callback
  param: ReturnData: {"Book":{"BookCategoryID":"03","BookSeqNo":"01","Name":

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function BackFromAppCallbackGetBookDefFromWeb (ReturnData) 
{
    console.log(COMP_NAME + ".BackFromAppCallbackGetBookDefFromWeb: ", ReturnData)

    // {"Book":{"BookCategoryID":"03","BookSeqNo":"01","Name":

    let objBookDef = ReturnData.Book
    let strBookSeqNo = objBookDef.BookSeqNo;                // 當成Key
    console.log("BackFromAppCallbackGetBookDefFromWeb: objBookDef: ", objBookDef)
    console.log("BackFromAppCallbackGetBookDefFromWeb: strBookSeqNo: ", strBookSeqNo)
    
    // BookDef[0] 塞 "BookSeqNo":"01" 資料，BookDef[1] 塞 "BookSeqNo":"02" 資料...
    window.gSession.App.BookDef[strBookSeqNo] = objBookDef

    console.log("BackFromAppCallbackGetBookDefFromWeb: JSON.stringify(window.gSession.App.BookDef):", JSON.stringify(window.gSession.App.BookDef))
    // check if non null for every book
    let blnEmptyBookObjectFound = false
    for (strBookSeqNo in window.gSession.App.BookDef) 
    {
        if (window.gSession.App.BookDef[strBookSeqNo] === null)
        {
            blnEmptyBookObjectFound = true
        }
    }

    console.log("BackFromAppCallbackGetBookDefFromWeb: window.gSession.App.BookDef: ", window.gSession.App.BookDef)
    if (!blnEmptyBookObjectFound)
    {
        // finished
        console.log("All Def of books are gotten!")
        // can disable loading mask?

        GetHomeworkDefinitionFromWeb(window.gSession.App.BookCatID)
    }
} // end of BackFromAppCallbackGetBookDefFromWeb

/*===========================================
summary: Web 取得 Homework 資料 
  param: BookCategoryID: 03

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetHomeworkDefinitionFromWeb (BookCategoryID)
{
    console.log(COMP_NAME + ".GetHomeworkDefinitionFromWeb: ", BookCategoryID)

    // BookCategoryID=03

    if (window.gSession.App.HomeworkDef !== null)
    {
        console.log("Homework Definition existed")
        GetPrerequisiteDataFromWebProcessEnd()
        return
    }

    // 左邊補零 Format "03"
    let strBookCategoryID = BookCategoryID.toString().PadLeft(2)

    menumGetJSONTypeTemp = window.gDCPJsonEnum.Homework
    GetDCPContentJson(menumGetJSONTypeTemp, strBookCategoryID)  
} // end of GetHomeworkDefinitionFromWeb

/*===========================================
summary: Web 取得 Homework 資料 Callback
  param: ReturnData: [{"BookCategoryID":"01","BookSeqNo":"01","LUCanBeChecked"

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function BackFromAppCallbackGetHomeworkDefinitionFromWeb (ReturnData) 
{
    console.log(COMP_NAME + ".BackFromAppCallbackGetHomeworkDefinitionFromWeb: ", ReturnData)

    window.gSession.App.HomeworkDef = ReturnData;  // array

    GetPrerequisiteDataFromWebProcessEnd()
} // end of BackFromAppCallbackGetHomeworkDefinitionFromWeb

/*===========================================
summary: Web 取得 Lesson 資料
  param: BookCategoryID: 03
         LessonID: 03001

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetLessonDefFromWeb (BookCategoryID, LessonID)
{
    console.log(COMP_NAME + ".GetLessonDefFromWeb: ", BookCategoryID, LessonID)

    // BookCategoryID=03&LessonID=03001

    // 先假設 BookCategoryID 一定一樣
    if (window.gSession.App.CurrentLesson.ID === LessonID)
    {
        console.log("the same with current Lesson")
        GetLessonDataFromWebProcessEnd(LessonID)
        // DCP.app.getControllerInstances()['DCP.controller.Lessons'].GoToLessonUnit(window.gSession.App.CurrentLesson.ID)
        return
    }

    // 左邊補零 Format "03"
    let strBookCategoryID = BookCategoryID.toString().PadLeft(2)

    // 左邊補零 Format "01001"
    let strLessonID = LessonID.toString().PadLeft(5)

    menumGetJSONTypeTemp = window.gDCPJsonEnum.Lesson
    GetDCPContentJson(menumGetJSONTypeTemp, strBookCategoryID, "", strLessonID)  
} // end of GetLessonDefFromWeb

/*===========================================
summary: Web 取得 Lesson 資料 Callback
  param: ReturnData: {"Lesson":{"ID":"03001","BookCategoryID":"03","BookSeqNo":"01","PrefixName"

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function BackFromAppCallbackGetLessonDefFromWeb (ReturnData) 
{
    console.log(COMP_NAME + ".BackFromAppCallbackGetLessonDefFromWeb: ", ReturnData)

    // {"Lesson":{"ID":"03001","BookCategoryID":"03","BookSeqNo":"01","PrefixName"

    let objLessonDef = ReturnData.Lesson
    let strLessonID = objLessonDef.ID; // 當成Key

    window.gSession.App.CurrentLesson.ID = strLessonID
    window.gSession.App.CurrentLesson.Def = objLessonDef
    console.log("BackFromAppCallbackGetLessonDefFromWeb: window.gSession.App.CurrentLesson.ID:", window.gSession.App.CurrentLesson.ID)
    console.log("BackFromAppCallbackGetLessonDefFromWeb: window.gSession.App.CurrentLesson.Def:", window.gSession.App.CurrentLesson.Def)
    // console.log("BackFromAppCallbackGetLessonDefFromWeb: JSON.stringify(window.gSession.App.CurrentLesson.Def):", JSON.stringify(window.gSession.App.CurrentLesson.Def))

    GetLessonDataFromWebProcessEnd(strLessonID)
} // end of BackFromAppCallbackGetLessonDefFromWeb
// ================== Web GetJSON END ==================


// ================== begin of access backend WS ==================
/*===========================================
summary: 取得Json檔
  param: 

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetDCPContentJson (JSONType, BookCategoryID, BookSeqNo, LessonID)
{
    console.log(COMP_NAME + ".GetDCPContentJson: ", JSONType, BookCategoryID, BookSeqNo, LessonID)

    let strBookCategoryID = BookCategoryID
    let strBookSeqNo = ""
    if ((typeof(BookSeqNo) !== 'undefined') && (BookSeqNo) !== "")
    {
        strBookSeqNo = BookSeqNo
    }
    let strLessonID = ""
    if ((typeof(LessonID) !== 'undefined') && (LessonID) !== "")
    {
        strLessonID = LessonID
    }

    let objRetryFuncRef = GetDCPContentJson

    if (!window.navigator.onLine)
    {
        GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
    }
    else
    {
        let objCallbackFuncRef = GetDCPContentJsonCallback
        // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

        // // Open Loading mask with message
        // this.OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetDCPContentJson)

        let objCallData = {
            "Func": "GetDCPContentJson",
            "Type": JSONType,
	        "BookCategoryID": strBookCategoryID,
	        "BookSeqNo": strBookSeqNo,
	        "LessonID": strLessonID
        }
        console.log("GetDCPContentJson: objCallData:", objCallData)
        NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
        .then(Response => {
            objCallbackFuncRef(Response)
        })
    }
} // end of GetDCPContentJson

/*===========================================
summary: 取得Json檔 Callback
  param: (Json Object) Return : 後端回傳的資料Json物件
         (int) InstructionInfo : 執行的第幾個後端要求事件

retruns: 
remarks: 000 Tim 2020/11/10 Create
===========================================*/
function GetDCPContentJsonCallback (Return, InstructionInfo)
{
	console.log(COMP_NAME + ".GetDCPContentJsonCallback: ", Return)
    console.log("GetDCPContentJsonCallback: Return.Data:", Return.Data)
    
    // Ext.Viewport.setMasked(false)
    
    // you need to customize these
    let intDefaultErrNo = window.gAppUI.ERR_GetDCPContentJson_No
    let strErrorTitle = window.gAppUI.ERR_GetDCPContentJson_Title
    let strErrMsg = window.gAppUI.ERR_GetDCPContentJson_Msg
    // end of customize

    if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
    {
        switch (Return.CalledErrNo)
        {
            // case customized error case:
            //     break
            default: 
                NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
            break
        }
    }
    else
    {
        // console.log("GetDCPContentJsonCallback: ", Return.Data)
        console.log("GetDCPContentJsonCallback: JsonParse(Return.Data):",JSON.parse(Return.Data))
        switch (menumGetJSONTypeTemp)
        {
            case window.gDCPJsonEnum.BookCategory:
                BackFromAppCallbackGetBookCategoryDefFromWeb(JSON.parse(Return.Data))
                break
            case window.gDCPJsonEnum.Book:
                BackFromAppCallbackGetBookDefFromWeb(JSON.parse(Return.Data))
                break
            case window.gDCPJsonEnum.Homework:
                BackFromAppCallbackGetHomeworkDefinitionFromWeb(JSON.parse(Return.Data))
                break
            case window.gDCPJsonEnum.Lesson:
                BackFromAppCallbackGetLessonDefFromWeb(JSON.parse(Return.Data))
                break
            default:
            	break
        }
    }
} // end of GetDCPContentJsonCallback
// ========= access backend WS END =========

export {
    // RegisterCallerWindownFuncRefs,
    // UnRegisterCallerWindownFuncRefs,
    
    GetPrerequisiteDataFromWebProcessBegin,
    GetLessonDataFromWebProcessBegin
}
